import TopBar from '../../components/Layout/TopBar';
import MyButton from '../../components/Layout/MyButton';
import ClipLoader from 'react-spinners/ClipLoader';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from '@mui/material';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {URL_API} from '../../utils/globalConfig';
import {logError} from '../../components/Utils/FormatData';
import {useNavigate} from 'react-router';
import useAuthz from '../../hooks/useAuthz';
import {useAlert} from 'react-alert';
import { faCheck, faList, faPen, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import MyDialog from '../../components/Layout/MyDialog';

const datasReferentielStyle = {
  cellHeader: {fontSize: '12px', color: 'white', border: '0', borderRight: '1px solid #ffffff4d', textTransform: 'uppercase',},
  rowDeleted: {backgroundColor: '#5a6e7430'},
  iconTable: {color: '#bb0060', height: '13px', padding: '0 10px', cursor: 'pointer'},
  classicInput: {border: 'none', outline: 'none', width: '90%'}
};

const EditMetadatasReferentiel = (props) => {
  const referentielName = new URLSearchParams(location.search).get("name")
  const alert = useAlert();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [dialogData, setDialogData] = useState({type: '', data: {}});
  const [openDialog, setOpenDialog] = useState(false);
  const [authz, user, profil] = useAuthz();
  const [isLoading, setIsLoading] = useState(true);
  const [listeDataReferentiel, setListeDataReferentiel] = useState([]);
  const [dialogState, setDialogState] = useState(null);
  const [edition, setEdition] = useState(false);
  const [elementToEdit, setElementToEdit] = useState({key: null, value: null});
  const [referentielMetadata, setReferentielMetadata] = useState({editedKey: '', editedValue: '', newKey: '', newValue: ''})

  //#region useEffect

  useEffect(() => {
    if (profil.profil === 6) {
      alert.error('Vous n\'êtes pas autorisé à accéder aux données du référentiel');
      navigate('/');
    } else {
      document.title = 'TE - Données du référentiel';
      getDatasReferentiel()
    }
  }, []);
  useEffect(() => {
    if (dialogState && dialogData.data) {
      listeDataReferentiel.splice(listeDataReferentiel.indexOf(dialogData.data), 1);
      let newTab = listeDataReferentiel.slice();
      setListeDataReferentiel(newTab);
      editDatasReferentiel()
    }
    setDialogState(null);
  }, [dialogState]);

  //#endregion

  //#region Fonctions

  const handleOnDelete = (element) => {
    setDialogData({...dialogData, data: element, type: 'delete'});
    setContent(() => {
      return (<>
        <div>Êtes-vous sur de vouloir supprimer ce tuple clé/valeur du référentiel : [<b>{element.key} / {element.value}</b>] ?</div>
      </>)
    });
    setOpenDialog(true);
  };
  const handleOnEdit = (element) => {
    setElementToEdit(element);
    setReferentielMetadata({editedKey: element.key, editedValue: element.value})
    setEdition(!edition);
  };
  const handleOnEditValidate = (elementToEdit) => {
    listeDataReferentiel[listeDataReferentiel.indexOf(elementToEdit)] = ({key: document.getElementById('editedKey').value, value: document.getElementById('editedValue').value.split(",")});
    let newTab = listeDataReferentiel.slice();
    setListeDataReferentiel(newTab);
    setEdition(!edition);
    editDatasReferentiel()
  };
  const add = (key, value) => {
    let valueIsValid = true;

    if (key === '' || value === '') {
      alert.error('Vous devez remplir les champs avant de continuer !');
      valueIsValid = false;
    } else {
      const element = {
        key: key, value: value.split(","),
      };

      listeDataReferentiel.map((elt) => {
        if (elt.key === element.key) {
          alert.error('Un élément possède déjà cet identifiant !');
          valueIsValid = false;
        }
      });

      if (valueIsValid) {
        listeDataReferentiel.push(element);
        let newTab = listeDataReferentiel.slice();
        setListeDataReferentiel(newTab);
        editDatasReferentiel()
      }
    }
    document.getElementById('newKey').value = '';
    document.getElementById('newValue').value = '';
  };
  const changeValue = (e) => {
    setReferentielMetadata({...referentielMetadata, [e.target.name]: e.target.value})
  };
  //#endregion

  //#region API

  const getDatasReferentiel = () => {
    axios({method: 'get', url: `${URL_API}/referentiel/datas`, params: {name: referentielName}})
      .then((res) => {
        setListeDataReferentiel(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        logError(alert, err);
      });
  };
  const editDatasReferentiel = () => {
    axios({
      method: 'post', url: `${URL_API}/referentiel/metadata/edit`, data: {
        name: referentielName, description: null, deleted: null, metadata: listeDataReferentiel,
      }, params: {referentielName: referentielName, userAction: user.user_id}
    })
      .then(() => {
        alert.removeAll();
        alert.success("L'édition a été enregistrée ! ");
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.response.data.message);

      });
  };

  //#endregion

  return (<div style={{height: 'calc(100% - 50px)'}}>
    <TopBar title={`Données du référentiel [${referentielName}]`} className='topbar-contenu' color={props.params.color}
            buttons={<div className='topbar-buttons'>
              <MyButton onClick={() => navigate('/panneau-administration/referentiel')} icon={faList} label={'Retour à la liste des référentiels'}/>
            </div>}
    />

    <div className='row' style={{margin: 0, overflow: 'hidden'}}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
      {!isLoading && (<Paper style={{height: '100%', width: '100%', borderTop: '1px solid #4db4da'}}>
        {referentielName && true && (<TableContainer component={Paper} style={{overflow: 'auto', height: '100%'}}>
          <Table aria-label='simple table'>
            <TableHead style={{backgroundColor: '#0094ca'}}>
              <TableRow>
                <TableCell align="center" style={datasReferentielStyle.cellHeader}>Actions</TableCell>
                <TableCell align="center" style={datasReferentielStyle.cellHeader}>Identifiant</TableCell>
                <TableCell align="center" style={datasReferentielStyle.cellHeader}>Nom</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listeDataReferentiel.map((element, index) => (<TableRow key={'row-' + index}>
                <TableCell align="center">
                  {edition && element.key === elementToEdit.key ? <FontAwesomeIcon icon={faCheck} style={datasReferentielStyle.iconTable}
                                                                                   onClick={() => handleOnEditValidate(element)}>
                  </FontAwesomeIcon> : <FontAwesomeIcon icon={faPen} style={datasReferentielStyle.iconTable}
                                                        onClick={() => handleOnEdit(element)}>
                  </FontAwesomeIcon>}
                  <FontAwesomeIcon icon={faTrash} style={datasReferentielStyle.iconTable}
                                   onClick={() => handleOnDelete(element)}>
                  </FontAwesomeIcon>
                </TableCell>
                <TableCell>{edition && element.key === elementToEdit.key ?
                  <TextField type='text' name='editedKey' id='editedKey' value={referentielMetadata.editedKey || ''} onChange={changeValue}
                             style={datasReferentielStyle.classicInput}/> :
                  <TextField fullWidth={true} inputProps={{readOnly: true}} value={element.key} style={datasReferentielStyle.classicInput}/>}</TableCell>
                <TableCell>
                  {edition && element.key === elementToEdit.key ?
                  <TextField type='text' name='editedValue' id='editedValue' value={referentielMetadata.editedValue || ''} onChange={changeValue}
                             style={datasReferentielStyle.classicInput}/> :
                  <TextField fullWidth={true} inputProps={{readOnly: true}} value={element.value} style={datasReferentielStyle.classicInput}/>
                  }
                </TableCell>
              </TableRow>))}
              <TableRow>
                <TableCell align="center">
                  <FontAwesomeIcon icon={faPlus} style={datasReferentielStyle.iconTable}
                                   onClick={() => add(document.getElementById('newKey').value, document.getElementById('newValue').value)}>
                  </FontAwesomeIcon>
                </TableCell>
                <TableCell><TextField onChange={changeValue} label={'Identifiant'} type='text' name='newKey' id='newKey'
                                      style={datasReferentielStyle.classicInput}></TextField></TableCell>
                <TableCell><TextField onChange={changeValue} label={'Valeurs (séparées par une virgule)'} type='text' name='newValue' id='newValue'
                                      style={datasReferentielStyle.classicInput}></TextField></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>)}
      </Paper>)}
    </div>

    <MyDialog open={openDialog} handleClose={setOpenDialog} title='Gestion des valeurs du référentiel' content={content} dialog={setDialogState}/>
  </div>);
};

export default EditMetadatasReferentiel;
